import { Component } from '@angular/core';
import { ToggleService } from '../../shared/services/toggle.service';

@Component({
  selector: 'app-intro-video-wrapper',
  template: `
    @if (isBunny) {
      <app-bunny-intro-video />
    } @else {
      <app-intro-video />
    }
  `,
  standalone: false
})
export class IntroVideoWrapperComponent {
  isBunny: boolean;

  constructor(toggleService: ToggleService) {
    this.isBunny = toggleService.isEnabled('bunny');
  }
}
